module.exports = __webpack_public_path__ + "static/product-ac30-1fbe6c65ac7b78a4754b8fb0e4366809.png";